import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TopBar, Field } from "@/components/Shell";
import { AUTH } from "@/constants/testIds";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Loader2, LogIn } from "lucide-react";

export default function AdminLoginPage() {
  const { user, checked, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user && user !== false) nav("/admin", { replace: true });
  }, [checked, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen">
      <TopBar mode="public" />
      <div className="max-w-md mx-auto px-5 py-20">
        <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-black/60 mb-1">
          Restricted
        </div>
        <h1 className="font-display text-5xl uppercase mb-1">Admin console</h1>
        <p className="text-black/70 mb-8">
          Sign in with your admin or project manager credentials.
        </p>

        <form onSubmit={submit} className="brut-card p-6 space-y-5">
          <Field label="Email" required>
            <input
              type="email"
              className="input-brut"
              data-testid={AUTH.loginEmail}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </Field>
          <Field label="Password" required>
            <input
              type="password"
              className="input-brut"
              data-testid={AUTH.loginPassword}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>
          {err && (
            <div
              data-testid={AUTH.loginError}
              className="pill pill-danger w-full justify-start"
            >
              {err}
            </div>
          )}
          <button
            type="submit"
            data-testid={AUTH.loginSubmit}
            disabled={loading}
            className="btn-brut btn-flame w-full"
          >
            {loading ? <Loader2 className="animate-spin" size={16} /> : <LogIn size={16} />}
            Sign in
          </button>
        </form>

        <div className="dashed-line my-8" />
        <div className="text-xs font-mono uppercase tracking-widest text-black/60">
          Demo credentials
        </div>
        <div className="mt-2 grid grid-cols-3 gap-3">
          <div className="brut-card p-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-black/60">Super Admin</div>
            <div className="text-sm font-mono truncate">admin@ftth.io</div>
            <div className="text-sm font-mono">admin123</div>
          </div>
          <div className="brut-card p-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-black/60">PM</div>
            <div className="text-sm font-mono truncate">pm@ftth.io</div>
            <div className="text-sm font-mono">pm12345</div>
          </div>
          <div className="brut-card p-3">
            <div className="text-[10px] font-mono uppercase tracking-widest text-black/60">KAO Admin</div>
            <div className="text-sm font-mono truncate">kao@ftth.io</div>
            <div className="text-sm font-mono">kao12345</div>
          </div>
        </div>

        <div className="mt-6">
          <Link to="/" className="btn-brut btn-ghost text-xs">← Back to site</Link>
        </div>
      </div>
    </div>
  );
}
